import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PresetDirective, PresetsDirective } from './presets.directive';
import { DateRangePickerComponent } from './daterangepicker.component';
import { DateRangePickerModule } from './daterangepicker.module';
/**
 * NgModule definition for the DateRangePicker component with providers.
 */
export class DateRangePickerAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, DateRangePickerModule],
    exports: [
        DateRangePickerModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DateRangePickerAllModule_tsickle_Closure_declarations() {
/** @type {?} */
DateRangePickerAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DateRangePickerAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
